var _defs, _rect, _path, _path2, _path3, _path4, _path5, _circle, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMacsUserMangmtIconSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-831f013e-f94b-4eb3-b737-2c120e0852ae",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-fcf28f74-c105-4f19-a7e5-6cfd69ea9e1d{fill:#fff;}.uuid-ca7fa220-794f-466d-8934-20ccef927017{fill:#ab89c8;}.uuid-53f42879-6e93-498b-9e68-528bf723abfb{fill:#bca1d3;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-ca7fa220-794f-466d-8934-20ccef927017",
    y: 0,
    width: 56,
    height: 56,
    rx: 8,
    ry: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-53f42879-6e93-498b-9e68-528bf723abfb",
    d: "M52,37.25V8c0-2.21-1.79-4-4-4H8c-2.21,0-4,1.79-4,4V48c0,2.21,1.79,4,4,4h29.25c1.05,0,2.06-.42,2.8-1.16l10.79-10.79c.74-.74,1.16-1.75,1.16-2.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fcf28f74-c105-4f19-a7e5-6cfd69ea9e1d",
    d: "M44.54,39.87c-.93,0-1.68-.76-1.68-1.69v-11.56l-1.59-.79c-.83-.42-1.17-1.43-.75-2.26,.29-.58,.87-.93,1.51-.93,.26,0,.52,.06,.75,.18l2.52,1.26c.58,.29,.93,.87,.93,1.51v12.6c0,.93-.76,1.69-1.69,1.69Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fcf28f74-c105-4f19-a7e5-6cfd69ea9e1d",
    d: "M36.82,39.87c-.93,0-1.68-.76-1.68-1.69V20.51l-7.14-4.76-7.14,4.76v17.67c0,.93-.76,1.69-1.68,1.69s-1.69-.76-1.69-1.69V19.84c0-.76,.36-1.42,.96-1.77l8.38-5.58c.34-.23,.74-.35,1.16-.35,.37,0,.76,.1,1.13,.28l8.45,5.62c.6,.41,.94,1.06,.94,1.8v18.35c0,.93-.76,1.69-1.69,1.69Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fcf28f74-c105-4f19-a7e5-6cfd69ea9e1d",
    d: "M26.32,39.87c-1.16,0-2.11-.94-2.11-2.1v-4.04c0-1.16,.94-2.11,2.11-2.11h3.36c1.18,0,2.11,.95,2.11,2.15v4c0,1.16-.94,2.1-2.11,2.1h-3.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fcf28f74-c105-4f19-a7e5-6cfd69ea9e1d",
    d: "M11.46,39.87c-.93,0-1.69-.76-1.69-1.69v-12.6c0-.64,.36-1.22,.93-1.51l2.52-1.26c.24-.12,.49-.18,.75-.18,.64,0,1.22,.36,1.51,.93,.42,.83,.08,1.84-.75,2.26l-1.59,.8v11.56c0,.93-.76,1.69-1.68,1.69Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-fcf28f74-c105-4f19-a7e5-6cfd69ea9e1d",
    cx: 28,
    cy: 24.77,
    r: 3.79
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-53f42879-6e93-498b-9e68-528bf723abfb",
    d: "M29.51,24.01h-.76s0-.76,0-.76c0-.42-.34-.76-.76-.76s-.76,.34-.76,.76v1.51c0,.46,.34,.76,.8,.76h1.47c.42,0,.76-.34,.76-.76,0-.37-.34-.76-.76-.76Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacsUserMangmtIconSchool);
export default __webpack_public_path__ + "static/media/MACS-UserMangmt-Icon-School.d3d353aee2a65bf05c6935a65a9a97d2.svg";
export { ForwardRef as ReactComponent };